import { useEffect, useState } from 'react';
import { AutoComplete, Button } from 'antd';
import { debounce } from 'common';

const LIMIT_SIZE = 20;

export const SelectOrganization = props => {
  const { collapsed } = nx.$root.layout;
  const [items, setItems] = useState([]);
  const [value, setValue] = useState('');
  const [selectMode, setSelectMode] = useState(false);
  const { organizations } = alo7Account;
  const hasOrganization = alo7Account.permissions.accessOrganization && organizations.length > 0;

  if (!hasOrganization) return null;

  const process = inData => {
    const data = inData.slice(0, LIMIT_SIZE);
    // { uuid: "348", value: "【删除】石家庄爱华外国语学校" }
    setItems(nx.keyMap(data, { uuid: 'value', value: 'text' }));
  };

  useEffect(() => {
    const res = value ? organizations.filter(item => item.value.includes(value)) : organizations;
    process(res);
  }, [organizations, value]);

  const handleSearch = debounce(e => {
    setValue(e);
  }, 200);

  const handleSelect = (val, options) => {
    const targetUrl = nx.param(
      {
        access_token: alo7Account.token,
        platform: 'external',
        referer: 'aosp',
        schoolId: val,
        subject: 'english',
        subuserId: alo7Account.aospSubUserId,
      },
      `/course`
    );
    setSelectMode(false);
    setValue('');
    window.open(targetUrl, '_blank');
  };

  return (
    <View mt={16} wp={9} auto>
      <nx.$rc.ife virtual value={selectMode}>
        <AutoComplete
          disabled={collapsed}
          placeholder="请输入机构名搜索"
          className="w100"
          allowClear
          dataSource={items}
          showSearch
          onSelect={handleSelect}
          onSearch={handleSearch}
        />
        <Button
          disabled={collapsed}
          icon="login"
          className="w100"
          onClick={() => {
            setSelectMode(true);
          }}>
          {!collapsed && '机构课程管理'}
        </Button>
      </nx.$rc.ife>
    </View>
  );
};
